import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapDirectorMailingFromServer = getDataMapper({
    campaign: mapField("campaign"),
    subject: mapField("subject"),
    sentAt: mapField("sent_at"),
    opened: mapField("opened", Boolean),
    clicked: mapField("clicked", Boolean),
    status: mapField("status"),
});

export const mapDirectorMailingsFromServer = mapArray(
    mapDirectorMailingFromServer,
);
